import { CARD_BINDING_PROVIDER_LABELS, CARD_NETWORK_LABELS } from "../constants/cardBinding";

export const formatCardProvider = (provider) =>
  CARD_BINDING_PROVIDER_LABELS[provider] || provider || "-";

export const formatCardNetwork = (network) =>
  CARD_NETWORK_LABELS[network] || network || "";

// expiryMonth is MM and expiryYear is YY; either can be missing when Paydibs returned no card details
export const formatCardExpiry = (month, year) => (month && year ? `${month}/${year}` : "-");

// "Visa ****3052", or "-" when the bind has no card details
export const formatCardSummary = ({ cardNetwork, displayPan } = {}) =>
  [formatCardNetwork(cardNetwork), displayPan].filter(Boolean).join(" ") || "-";
